import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Portal } from 'react-portal';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import branch from 'client/core/branch';

export const SR_DIALOG_ACTION_THEME_DANGER = 'SR_DIALOG_ACTION_THEME_DANGER';
export const SR_DIALOG_ACTION_THEME_ACTIVE = 'SR_DIALOG_ACTION_THEME_ACTIVE';
const SR_DIALOG_ACTION_THEME_TO_CLASSNAME_MAPPING = {
  [SR_DIALOG_ACTION_THEME_DANGER]: 'red',
  [SR_DIALOG_ACTION_THEME_ACTIVE]: 'active',
};
const SR_DIALOG_ACTION_THEMES = Object.keys(SR_DIALOG_ACTION_THEME_TO_CLASSNAME_MAPPING);

@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrDialogActionModal extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      theme: PropTypes.oneOf(SR_DIALOG_ACTION_THEMES),
    })).isRequired,
    onClose: PropTypes.func.isRequired,
    onClickAction: PropTypes.func.isRequired,
    userAgent: PropTypes.object.isRequired,
  };

  render() {
    const { userAgent, onClose, isOpen, title, actions, onClickAction } = this.props;

    if (!isOpen) {
      return null;
    }

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames(
            'darkModal',
            'darkNavigator',
            { webview: isMobileApp },
          )}
        >
          <div className='choiceContainer' onClick={preventDefaultPropagation}>
            <div className='choiceGroup'>
              <div className='topLabel'>
                <span>{title}</span>
              </div>

              {actions.map((action) => (
                <span
                  key={action.id}
                  onClick={() => onClickAction(action.id)}
                  className={classnames('choice', SR_DIALOG_ACTION_THEME_TO_CLASSNAME_MAPPING[action.theme])}
                >
                  {action.text}
                </span>
              ))}
            </div>
            <div
              className='choice solo'
              onClick={onClose}
            >
              <span>Cancel</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrDialogActionModal.displayName = 'SrDialogActionModal';

export default SrDialogActionModal;
